import React, { Suspense, lazy } from "react";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import TravelHospitality from "./Components/TravelHospitality/TravelHospitality.js";
import Retail from "./Components/Retail/Retail.js";
import Telecom from "./Components/Telecom/Telecom.js";
import Health from "./Components/Health/Health.js";
import Insurance from "./Components/Insurance/Insurance.js";
import RealEstate from "./Components/RealEstate/RealEstate.js";
import Logistic from "./Components/Logistic/Logistic.js";

import { logout } from "./redux/authSlice";
import ScrollToTop from "./ScrollToTop";
import LandingPage from "./Components/HomeComponent/LandingPage/LandingPage.jsx";
import ExploreVoices from "./Components/HomeComponent/NewLandingComponents/LandingPageSection3/ExploreVoices/ExploreVoices.jsx";
import ConnectWhatsApp from "./Components/WhatsApp/ConnectWhatsApp.jsx";
import LeadQualification from "./NewCompoents/SalesAgent/LeadQualification/LeadQualification.jsx";
import SalesPitchAutomation from "./NewCompoents/SalesAgent/SalesPitchAutomation/SalesPitchAutomation.jsx";
import FollowUpManagement from "./NewCompoents/SalesAgent/FollwUpManagement/FollowUpManagement.jsx";

import SalesAndMarketing from "./Components/SalesAndMarketing/SalesAndMarketing.jsx";
import Collection from "./Components/Collection/Collection.jsx";
import CustomerSupport from "./Components/Customer-Support Page/Customer-Support.jsx";


// industies pages routes
import FooterHelpCenter from "./Components/IndustriesPages/HelpCenter/FooterHelpCenter.jsx";
import Faqpage from "./Components/IndustriesPages/FAQ/Faqpage.jsx";
import CostumerSupport from "./Components/IndustriesPages/CostumerSupport/CostumerSupport.jsx";
import Blogupdates from "./Components/IndustriesPages/BlogUpdates/Blogupdates.jsx";
import TexttoSpeech from "./NewCompoents/ProductsPages/TexttoSpeech/TexttoSpeech.jsx";
// import SalesMarketing from "./NewCompoents/Rag/Sales&Marketing/SalesMarketing.js";
// TravelHomeSection imported in Blogupdates.jsx where needed

import Chatbot from "./NewCompoents/ProductsPages/Chatbot/Chatbot.jsx";
import SpeechToText from "./NewCompoents/ProductsPages/SpeechtoText/SpeechToText.jsx";
import VoiceAIAgents from "./NewCompoents/ProductsPages/VoiceAIAgents/VoiceAIAgents.jsx";
import BPO from "./Components/BPO/Bpo_Contact_Center.jsx";
import ECommerce from "./Components/ECommerce/ECommerce.jsx";
import AutoMobile from "./Components/Automobile/Automobile.jsx";
////

import Pricing from "./Components/Pricing/Pricing";
import Features from "./Components/Features/Features";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import TermsOfService from "./Components/Pages/TermsOfService";
import HelpCenter from "./Components/Pages/HelpCenter";
import ContactUs from "./Components/Pages/ContactUs";
import AddPhoneNumber from "./Components/NumberManagement/AddPhoneNumber"; // Added

const CreateProject = lazy(() => import("../src/NewCompoents/Client/Project/CreateProject"));
const Approval = lazy(() => import("./Components/Admin/Approval"));
const AudioPage = lazy(() => import("./Components/AudioPage/AudioPage"));
const AuthComponent = lazy(() => import("./Components/AuthComponent/AuthComponent"));
const Blog = lazy(() => import("./Components/Blog/Blog"));
const CallTypeComponent = lazy(() => import("./Components/CallTypeComponent/CallTypeComponent"));
const CreateInBoundAgentComponent = lazy(() => import("./Components/CreateAgentComponent/CreateInBoundAgentComponent"));
const CreateOutBoundAgentComponent = lazy(() => import("./Components/CreateAgentComponent/CreateOutBoundAgentComponent"));
// const CustomerSupport = lazy(() => import("./Components/CustomerSupport/CustomerSupport"));
// const HelpCenter = lazy(() => import("./Components/HelpCenter/HelpCenter")); // Commented out old one to use new
const FaqComponent = lazy(() => import("./Components/FaqComponent/FaqComponent"));
const HomeComponent = lazy(() => import("./Components/HomeComponent/HomeComponent"));
const InboundTemplate = lazy(() => import("./Components/InboundTemplate/InboundTemplate"));
const KnowledgeBase = lazy(() => import("./Components/KnowledgeBase/KnowledgeBase"));
const NumberManagement = lazy(() => import("./Components/NumberManagement/NumberManagement"));
const OutboundCallDashboard = lazy(() => import("./Components/OutboundCallDashboard/OutboundCallDashboard"));
const OutboundTemplate = lazy(() => import("./Components/OutboundTemplate/OutboundTemplate"));
// const PrivacyPolicy = lazy(() => import("./Components/PrivacyPolicy/PrivacyPolicy"));
const Campaign = lazy(() => import("./Components/RealStateVendor/Campaign"));
const Developer = lazy(() => import("./Components/RealStateVendor/Developer"));
const ResultComponent = lazy(() => import("./Components/ResultComponent/ResultComponent"));
const ScriptandApi = lazy(() => import("./Components/Script&Api/ScriptandApi"));
const Setting = lazy(() => import("./Components/Setting/Setting"));
const Sidebar = lazy(() => import("./Components/Sidebar/Sidebar"));
const TemplateComponent = lazy(() => import("./Components/TemplateComponent/TemplateComponent"));
// const TermsOfService = lazy(() => import("./Components/TermsOfService/TermsOfService"));
const ToxboxSection = lazy(() => import("./Components/ToxboxSection/ToxboxSection"));
const VoiceComponent = lazy(() => import("./Components/VoiceComponent/VoiceComponent"));
const AdminDashboard = lazy(() => import("./NewCompoents/Admin/AdminDashboard/AdminDashboard"));
const AssignComponent = lazy(() => import("./NewCompoents/AssignComponent/AssignComponent"));
const CallBook = lazy(() => import("./NewCompoents/CallBook/CallBook"));
const CallDetails = lazy(() => import("./NewCompoents/Client/CallHistory/CallDetails"));
const HeaderBar = lazy(() => import("./NewCompoents/HeaderBar/HeaderBar"));
const SubAdminDashboard = lazy(() => import("./NewCompoents/SubAdmin/SubAdminDashboard/SubAdminDashboard"));
const UserManagement = lazy(() => import("./NewCompoents/UserManagement/UserManagement"));
const VendorBalancePage = lazy(() => import("./NewCompoents/VendorBalancePage/VendorBalancePage"));
const AgentAssignComponent = lazy(() => import("./Components/AgentAssignComponent/AgentAssignComponent"));
const EditAgentComponent = lazy(() => import("./Components/EditAgentComponent/EditAgentComponent"));
const ShowTicket = lazy(() => import("./Components/HelpCenter/ShowTicket"));
const NewChatBot = lazy(() => import("./Components/NewChatbot/NewChatBot"));
const ActivityPage = lazy(() => import("./Components/ActivityManagement/ActivityPage"));
const VendorDashboard = lazy(() => import("./Components/VendorDashboard/VendorDashboard"));
const BalanceStatement = lazy(() => import("./NewCompoents/BalanceStatement/BalanceStatement"));
const CallLogsCampaign = lazy(() => import("./NewCompoents/CallLogsCampaign/CallLogsCampaign"));
const CallHistory = lazy(() => import("./NewCompoents/Client/CallHistory/CallHistory"));
const Playground = lazy(() => import("./NewCompoents/Playground/Playground"));
const CorpusSources = lazy(() => import("./NewCompoents/Rag/CorpusSources"));
const VendorKnowledge = lazy(() => import("./NewCompoents/Rag/VendorKnowledge"));
const AgentScriptFull = lazy(() => import("./NewCompoents/SalesPerson/SalesPersonDashboard/AgentScriptFull"));
const SalesPersonDashboard = lazy(() => import("./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonDashboard"));
const SalesPersonInfo = lazy(() => import("./NewCompoents/SalesPerson/SalesPersonDashboard/SalesPersonInfo"));
// const LeadQualification = lazy(() => import("../src/NewCompoents/SalesAgent/LeadQualification"));
const NewandMedia = lazy(() => import("./Components/AINews&Media/NewandMedia.js"));
const AIRecruiter = lazy(() => import("./Components/AIRecruiter/AIRecruiter.js"));
const AITechSupport = lazy(() => import("./Components/AITechSupport/AITechSupport"));
const HardwareSupport = lazy(() => import("./Components/HardwareSupport/HardwareSupport"));
const DynamicPage = lazy(() => import("./Components/HomeComponent/DynamicPage/DynamicPage"));
const Navbar = lazy(() => import("./Components/HomeComponent/Navbar"));
const SoftwareAssistance = lazy(() => import("./Components/SoftwareAssistance/SoftwareAssistance"));
const WhyToxbox = lazy(() => import("./Components/WhyUs/WhyToxbox"));
const DemoForm = lazy(() => import("./NewCompoents/Demoform/DemoForm"));
const DemoList = lazy(() => import("./NewCompoents/Demoform/DemoList/DemoList"));
const LiveChatSupport = lazy(() => import("./NewCompoents/LiveChatSupport/LiveChatSupport"));
const TicketResolution = lazy(() => import("./NewCompoents/TicketResolution/TicketResolution"));
const Careers = lazy(() => import("./Components/Career/Careers"));
const FooterComponent = lazy(() => import("./Components/Footer/FooterComponent"));
const KeysComponent = lazy(() => import("./Components/KeysComponent/KeysComponent"));
const ConnectMetaAds = lazy(() => import("./Components/MetaIntegration/ConnectMetaAds"));
const CampaignsDashboard = lazy(() => import("./Components/MetaIntegration/CampaignsDashboard"));
const LeadsDashboard = lazy(() => import("./Components/MetaIntegration/LeadsDashboard"));
const MultiStepForm = lazy(() => import("./Components/MultiStepForm/MultiStepForm"));
const RecruiterAgnetPage = lazy(() => import("./Components/Recruiter/RecruiterAgent/MultiStepForm/RecruiterAgentPage"));
const ApiKeyGenerator = lazy(() => import("./Components/Recruiter/RecruiterApiKey/ApiKeyGenerator"));
const AllRecuiretAgents = lazy(() => import("./Components/Recruiter/AllRecuiretAgents/AllRecuiretAgents"));
const RecriterScriptandApi = lazy(() => import("./Components/Recruiter/RecruiterAgent/Script&Api/RecruiterScriptandApi"));
const RecruiterKnowledge = lazy(() => import("./Components/Recruiter/RecruiterAgent/Rag/RecruiterKnowledge"));
const AssesmentAnalysis = lazy(() => import("./NewCompoents/Interviewer/Assesment-Analysis/AssesmentAnalysis"));
const InterviewPlatform = lazy(() => import("./Components/InterviewPlatform/InterviewPlatform"));
const InterviewComplete = lazy(() => import("./Components/InterviewPlatform/InterviewComplete"));
const ResumeScreen = lazy(() => import("./NewCompoents/ResumeScreen/ResumeScreen"));
const CampaignManager = lazy(() => import("../src/ElectionPartyComponent/CampaignManager"));
const ElectionPromptTemplate = lazy(() => import("../src/ElectionPartyComponent/ElectionPromptTemplate"));
const ElectionAgentTemplate = lazy(() => import("./ElectionPartyComponent/ElectionAgentTemplate"));
const CreateElectionOutBoundAgentComponent = lazy(() => import("./ElectionPartyComponent/CreateElectionOutBoundAgentComponent"));
const ElectionEditOutboundAgent = lazy(() => import("./ElectionPartyComponent/ElectionEditOutboundAgent"));
const ElectionCallerbook = lazy(() => import("./ElectionPartyComponent/ElectionCallerbook"));
const CampaignCallTypeViewer = lazy(() => import("./Components/ElectionLog/CampaignCallTypeViewer"));
const CampaignCreditAssignment = lazy(() => import("./ElectionPartyComponent/CampaignCreditAssignment"));
const ElectionNumber = lazy(() => import("./Components/ElectionNumber/ElectionNumber"));
const ElectionDashboard = lazy(() => import("./ElectionPartyComponent/ElectionDashboard.jsx"));
const CustomerFeedback = lazy(() => import("./NewCompoents/CustomerSupport/CustomerFeedback.js"));
const CandidateOutreach = lazy(() => import("./Components/CandidateOutreach/CandidateOutreach.js"));
const LeadGeneration = lazy(() => import("./Components/LeadGeneration/LeadGeneration.js"));
const LeadNurturing = lazy(() => import("./Components/LeadNurturing/LeadNurturing.js"));
const CRMIntegration = lazy(() => import("./NewCompoents/CRMIntegration/CRMIntegration.jsx"));
const ReservationManagement = lazy(() => import("./NewCompoents/AIBookingAgent/ReservationManagement.jsx"));
const AppointmnetBooking = lazy(() => import("./NewCompoents/AIBookingAgent/Appointment Booking/AppointmnetBooking.jsx"));
const CalenderIntegration = lazy(() => import("./NewCompoents/AIBookingAgent/CalenderIntegration/CalenderIntegration.jsx"));
const Contact = lazy(() => import("./Components/Contactus/Contact.js"));
const InterviewScheduling = lazy(() => import("./NewCompoents/Interviewer/Interview-Scheduling/InterviewScheduling.jsx"));
const CandidateScreening = lazy(() => import("./NewCompoents/Interviewer/Candidate-Screening/CandidateScreening.jsx"));

const DevDashboard = lazy(() => import("./Components/DevDashboard.js"));
const BugReportButton = lazy(() => import("./Components/BugReportButton.jsx"));
const ChatbotSettings = lazy(() => import("./Components/Admin/ChatbotSettings/ChatbotSettings")); // Add imports after this line

// ToxBox CRM Domain Lazy Imports
const CRMDashboard = lazy(() => import("./NewCompoents/CRM/Dashboard/CRMDashboard"));
const CRMLeads = lazy(() => import("./NewCompoents/CRM/CRMLeads/CRMLeads"));
const LeadImport = lazy(() => import("./NewCompoents/CRM/LeadImport/LeadImport"));
const LeadDetails = lazy(() => import("./NewCompoents/CRM/LeadDetails/LeadDetails"));
const FollowupCalendar = lazy(() => import("./NewCompoents/CRM/Followup/FollowupCalendar"));
const Masters = lazy(() => import("./NewCompoents/CRM/Masters/Masters"));
const CRMReports = lazy(() => import("./NewCompoents/CRM/Reports/CRMReports"));
const LeadTemplates = lazy(() => import("./NewCompoents/CRM/LeadTemplates/LeadTemplates"));
const EmailTemplates = lazy(() => import("./NewCompoents/CRM/EmailTemplates/EmailTemplates"));

// B2B Components
const B2BDashboard = lazy(() => import("./NewCompoents/B2B/Dashboard/B2BDashboard"));
const B2BCampaignManager = lazy(() => import("./NewCompoents/B2B/Campaign/B2BCampaignManager"));
const B2BCallBook = lazy(() => import("./NewCompoents/B2B/CallBook/B2BCallBook"));
const B2BCallLogs = lazy(() => import("./NewCompoents/B2B/CallLogs/B2BCallLogs"));
const B2BAgentSelection = lazy(() => import("./NewCompoents/B2B/Agent/B2BAgentSelection"));
const B2BMultiStepForm = lazy(() => import("./NewCompoents/B2B/Agent/B2BMultiStepForm"));
const B2BChatbotList = lazy(() => import("./NewCompoents/B2B/Chatbot/B2BChatbotList"));
const B2BAgentList = lazy(() => import("./NewCompoents/B2B/Agent/B2BAgentList"));
const CreateB2BChatbot = lazy(() => import("./NewCompoents/B2B/Chatbot/CreateB2BChatbot"));
const PhoneNumberManager = lazy(() => import("./NewCompoents/B2B/PhoneNumber/PhoneNumberManager"));
const InterviewScreening = lazy(() => import("../src/Components/InterviewScrenning/InterviewScrenning.jsx"))


// const LeadQualification = lazy(() => import("./NewCompoents/SalesAgent/LeadQualification/LeadQualification.jsx"));


// import Contact from "./Components/ContactUs/Contact.js";
const LoadingFallback = () => (
  <div style={{
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.9)",
    zIndex: 9999,
    fontSize: "1.2rem"
  }}>
    Loading...
  </div>
);


const Dashboard = () => (
  <div style={{ padding: 24 }}>
    <h1>Dashboard </h1>
    <p>
      This is the Dashboard page (Health Care) — replace with real component.
    </p>
  </div>
);

const Patients = () => (
  <div style={{ padding: 24 }}>
    <h1>Patients</h1>
    <p>
      This is the Patients page (Health Care) — replace with real component.
    </p>
  </div>
);

const Appointments = () => (
  <div style={{ padding: 24 }}>
    <h1>Appointments</h1>
    <p>This is the Appointments page (Health Care).</p>
  </div>
);

const Doctors = () => (
  <div style={{ padding: 24 }}>
    <h1>Doctors</h1>
    <p>This is the Doctors page (Health Care).</p>
  </div>
);

// Fix: Replace recursive RecruiterDashboard with a placeholder
const RecruiterDashboard = () => (
  <div style={{ padding: 24 }}>
    <h1>Recruiter Dashboard</h1>
    <p>This is the Recruiter Dashboard — replace with real component.</p>
  </div>
);

const ProtectedRoute = ({ children, requiredRoles }) => {
  const dispatch = useDispatch();
  const { token, isAuthenticated, role } = useSelector((state) => state.auth);
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData?.user?.domain?.toLowerCase() || "default";
  const rawRole = role?.toLowerCase();
  const userRole = rawRole === "subclient" ? "vendor" : rawRole;

  // Move hooks to the top
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);
  const [hasAnimated, setHasAnimated] = React.useState(true);

  useEffect(() => {
    if (!token || !isAuthenticated) {
      console.warn("ProtectedRoute: No token found, redirecting to /");
      dispatch(logout());
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        console.warn("ProtectedRoute: Token expired, logging out");
        dispatch(logout());
        alert("Session expired. Please log in again.");
      }
    } catch (error) {
      console.error("ProtectedRoute: Error decoding token:", error);
      dispatch(logout());
    }
  }, [token, isAuthenticated, role, requiredRoles, dispatch]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    if (!hasAnimated) {
      setHasAnimated(true);
    }
  };

  const menuContext = location.pathname.startsWith("/outbound")
    ? "outbound-agent"
    : location.pathname.startsWith("/inbound")
      ? "inbound-agent"
      : "default";

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isAuthorized = !requiredRoles || requiredRoles.includes(userRole);

  if (!isAuthorized) {
    console.warn(`ProtectedRoute: Unauthorized role ${userRole}, redirecting to /`);
    return <Navigate to="/" replace />;
  }

  return (
    <div
      className="protected-content"
      style={{
        display: "flex",
        flexDirection: window.innerWidth >= 640 ? "row" : "column",
        overflow: "hidden"
      }}
    >
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        hasAnimated={hasAnimated}
        menuContext={menuContext}
      />
      <div className={`content ${isSidebarOpen ? "shifted" : ""}`}>
        <HeaderBar />
        {children}
        <BugReportButton />
      </div>
    </div>
  );
};

const RoleBasedDashboard = () => {
  const rawRole = useSelector((state) => state.auth.role)?.toLowerCase();
  const role = rawRole === "subclient" ? "vendor" : rawRole;
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData.user?.domain?.toLowerCase() || "default";

  if (!role) {
    console.warn("RoleBasedDashboard: No role found, redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  // Logic to determine dashboard based on role and domainType
  if (domainType === "recruiter") {
    switch (role) {
      case "vendor":
        return <RecruiterDashboard />;
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "participant":
        return <SalesPersonDashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  } else if (domainType === "health care") {
    switch (role) {
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "vendor":
        return <VendorDashboard />;
      case "participant":
        return <Dashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  } else if (domainType === "election party") {
    return <ElectionDashboard />;
  } else if (domainType === "b2b") {
    return <B2BDashboard />;
  } else {
    switch (role) {
      case "owner":
        return <AdminDashboard />;
      case "subowner":
        return <SubAdminDashboard />;
      case "vendor":
        return <VendorDashboard />;
      case "participant":
        return <SalesPersonDashboard />;
      default:
        console.warn("RoleBasedDashboard: Unknown role, redirecting to /login");
        return <Navigate to="/login" replace />;
    }
  }
};

// Public Route Layout Component
const PublicRouteLayout = ({ children }) => (
  <Suspense fallback={<LoadingFallback />}>
    <Navbar />
    {children}
    <FooterComponent />
  </Suspense>
);

const App = () => {
  const role = useSelector((state) => state.auth.role)?.toLowerCase() || null;
  const { isAuthenticated, token } = useSelector((state) => state.auth);
  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const domainType = userData.user?.domain?.toLowerCase() || "default";

  console.log("Domain from localStorage:", domainType);

  useEffect(() => {
    if (role && localStorage.getItem("role") !== role) {
      localStorage.setItem("role", role);
    }
  }, [role]);


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        style={{ zIndex: 999999, position: "fixed" }}
      />
      <Router>
        <ScrollToTop />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {/* Public Routes Wrapped with Navbar and Footer */}
            <Route
              path="/login"
              element={
                isAuthenticated && token ? (
                  <Navigate to="/" replace />
                ) : (
                  <AuthComponent />
                )
              }
            />

            {/* Public Routes */}
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route path="/contact" element={<ContactUs />} />

            {/* Activity Route Moved down to Protected Routes */}

            {/* Admin Routes */}
            <Route
              path="/admin/add-phone-number"
              element={
                <ProtectedRoute requiredRoles={["owner", "subowner"]}>
                  <AddPhoneNumber />
                </ProtectedRoute>
              }
            />

            <Route
              path="/travel-hospitality"
              element={
                <PublicRouteLayout>
                  <TravelHospitality />
                </PublicRouteLayout>
              }
            />



            <Route
              path="/retail"
              element={
                <PublicRouteLayout>
                  <Retail />
                </PublicRouteLayout>
              }
            />



            <Route
              path="/telecom"
              element={
                <PublicRouteLayout>
                  <Telecom />
                </PublicRouteLayout>
              }
            />





            <Route
              path="/Health"
              element={
                <PublicRouteLayout>
                  <Health />
                </PublicRouteLayout>
              }
            />





            <Route
              path="/Insurance"
              element={
                <PublicRouteLayout>
                  <Insurance />
                </PublicRouteLayout>
              }
            />







            <Route
              path="/Real-Estate"
              element={
                <PublicRouteLayout>
                  <RealEstate />
                </PublicRouteLayout>
              }
            />






            <Route
              path="/Logistic"
              element={
                <PublicRouteLayout>
                  <Logistic />
                </PublicRouteLayout>
              }
            />











            <Route
              path="/help"
              element={
                <PublicRouteLayout>
                  <HelpCenter />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/terms-of-service"
              element={
                <PublicRouteLayout>
                  <TermsOfService />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/privacy-Policy"
              element={
                <PublicRouteLayout>
                  <PrivacyPolicy />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/faq"
              element={
                <PublicRouteLayout>
                  <FaqComponent />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/blogs"
              element={
                <PublicRouteLayout>
                  <Blog />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/sales-automation/customersupport"
              element={
                <PublicRouteLayout>
                  <CustomerSupport />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/new-ChatBot"
              element={
                <PublicRouteLayout>
                  <NewChatBot />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/demo-form"
              element={
                <PublicRouteLayout>
                  <DemoForm />
                </PublicRouteLayout>
              }
            />


            {/* Inducstrie pages Routes */}

            {/* 1.HelpCenter */}
            <Route
              path="/industries/help-center"
              element={
                <PublicRouteLayout>
                  <FooterHelpCenter />
                </PublicRouteLayout>
              }
            />

            {/* 2. FAQ'S */}
            <Route
              path="/industries/faq"
              element={
                <PublicRouteLayout>
                  < Faqpage />
                </PublicRouteLayout>
              }
            />

            {/* 3.CostumerSupport */}
            <Route
              path="/industries/custumer-support"
              element={
                <PublicRouteLayout>
                  < CostumerSupport />
                </PublicRouteLayout>
              }
            />

            {/* 4.blog&updates */}
            <Route
              path="/industries/blog&updates"
              element={
                <PublicRouteLayout>
                  <Blogupdates />
                </PublicRouteLayout>
              }
            />


            {/*  AI-Recruiter Routes*/}

            <Route
              path="/ai-recruiter/sourcing"
              element={
                <PublicRouteLayout>
                  <AIRecruiter />
                </PublicRouteLayout>
              }
            />

            <Route
              path="ai-recruiter/resume"
              element={
                <PublicRouteLayout>
                  <ResumeScreen />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/ai-recruiter/outreach"
              element={
                <PublicRouteLayout>
                  <CandidateOutreach />
                </PublicRouteLayout>
              }
            />

            {/* Customer Support AI Routes*/}
            <Route
              path="/ai-support/live-chat"
              element={
                <PublicRouteLayout>
                  <LiveChatSupport />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-support/ticket-resolution"
              element={
                <PublicRouteLayout>
                  <TicketResolution />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-support/feedback"
              element={
                <PublicRouteLayout>
                  <CustomerFeedback />
                </PublicRouteLayout>
              }
            />


            {/* AI-sales Routes  */}
            <Route
              path="/ai-sales/lead-qualification"
              element={
                <PublicRouteLayout>
                  <LeadQualification />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-sales/pitch"
              element={
                <PublicRouteLayout>
                  <SalesPitchAutomation />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-sales/follow-up"
              element={
                <PublicRouteLayout>
                  <FollowUpManagement />
                </PublicRouteLayout>
              }
            />

            {/* Lead Agents Routes*/}

            <Route
              path="/ai-lead/generation"
              element={
                <PublicRouteLayout>
                  <LeadGeneration />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/ai-lead/nurturing"
              element={
                <PublicRouteLayout>
                  <LeadNurturing />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-lead/crm"
              element={
                <PublicRouteLayout>
                  <CRMIntegration />
                </PublicRouteLayout>
              }
            />




            <Route
              path="/why-us"
              element={
                <PublicRouteLayout>
                  <WhyToxbox />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/voices"
              element={
                <PublicRouteLayout>
                  <ExploreVoices />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/voice"
              element={
                <PublicRouteLayout>
                  <VoiceComponent />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/toxboxSection"
              element={
                <PublicRouteLayout>
                  <ToxboxSection />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/audios"
              element={
                <PublicRouteLayout>
                  <AudioPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-recuter"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-support"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-sales"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-booking"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            {/* AI Booking Agent Routes  */}
            <Route
              path="/ai-booking/appointment"
              element={
                <PublicRouteLayout>
                  <AppointmnetBooking />
                </PublicRouteLayout>

              } />

            <Route
              path="/ai-booking/reservation"
              element={
                <PublicRouteLayout>
                  <ReservationManagement />
                </PublicRouteLayout>

              } />

            <Route
              path="/ai-booking/calendar"
              element={
                <PublicRouteLayout>
                  <CalenderIntegration />
                </PublicRouteLayout>
              } />


            <Route
              path="/voice-ai"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />


            {/* Routes for the AI-Interview */}
            <Route
              path="/ai-interviewer/assessment"
              element={
                <PublicRouteLayout>
                  <AssesmentAnalysis />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/ai-interviewer/scheduling"
              element={
                <PublicRouteLayout>
                  <InterviewScheduling />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/interview-screnning"
              element={
                <PublicRouteLayout>
                  <InterviewScreening />
                </PublicRouteLayout>

              }
            />
            <Route
              path="/ai-interviewer/screening"
              element={
                <PublicRouteLayout>
                  <CandidateScreening />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/sport-agent"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/smart-agent"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/insights"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/gen-ai-consulting"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/poc-to-production"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/case-studies"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/reports"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/knowledge-center"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/blog"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/customer-showcase"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/tech-blog"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/webinars"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-conversations"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/partnerships"
              element={
                <PublicRouteLayout>
                  <DynamicPage />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/careers"
              element={
                <PublicRouteLayout>
                  <Careers />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/contact"
              element={
                <PublicRouteLayout>
                  <Contact />
                </PublicRouteLayout>
              }
            />

            {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
            {/* products pages routes */}

            <Route
              path="/products/chatbot"
              element={
                <PublicRouteLayout>
                  <Chatbot />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/products/speech"
              element={
                <PublicRouteLayout>
                  <SpeechToText />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/products/text"
              element={
                <PublicRouteLayout>
                  <TexttoSpeech />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/products/voice"
              element={
                <PublicRouteLayout>
                  <VoiceAIAgents />
                </PublicRouteLayout>
              }
            />
            {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
            <Route
              path="/ai-tech/troubleshooting"
              element={
                <PublicRouteLayout>
                  <AITechSupport />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-tech/software"
              element={
                <PublicRouteLayout>
                  <SoftwareAssistance />
                </PublicRouteLayout>
              }
            />
            <Route
              path="/ai-tech/hardware"
              element={
                <PublicRouteLayout>
                  <HardwareSupport />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/sales-automation/salesmanagement"
              element={
                <PublicRouteLayout>
                  <SalesAndMarketing />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/industries/e-commerce"
              element={
                <PublicRouteLayout>
                  <ECommerce />
                </PublicRouteLayout>
              }
            />

            <Route
              path="/industries/Automobile"
              element={
                <PublicRouteLayout>
                  <AutoMobile />
                </PublicRouteLayout>
              }
            />

            {/* <Route
              path="/industries/Logistics"
              element={
                <PublicRouteLayout>
                  <Logistics/>
                </PublicRouteLayout>
              }
            /> */}

            <Route
              path="/industries/BPO"
              element={
                <PublicRouteLayout>
                  <BPO />
                </PublicRouteLayout>
              }
            />

            <Route
              path="sales-automation/collection"
              element={
                <PublicRouteLayout>
                  <Collection />
                </PublicRouteLayout>
              }
            />
            {/* Protected Routes */}
            <Route
              path="/"
              element={
                role ? (
                  <ProtectedRoute
                    requiredRoles={["owner", "subowner", "vendor", "participant"]}
                  >
                    <RoleBasedDashboard />
                  </ProtectedRoute>
                ) : (
                  <PublicRouteLayout>
                    <LandingPage />
                  </PublicRouteLayout>
                )
              }
            />
            <Route
              path="/user-management"
              element={
                <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/activity"
              element={
                <ProtectedRoute requiredRoles={["owner", "subowner", "vendor", "participant", "salesperson"]}>
                  <ActivityPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agents-template"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <ElectionAgentTemplate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/election-campaign"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <CampaignManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/call-logs"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <CampaignCallTypeViewer />
                </ProtectedRoute>}
            />

            <Route
              path="/assignCredit"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <CampaignCreditAssignment />
                </ProtectedRoute>}
            />
            <Route
              path="/election/create-agent"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <CreateElectionOutBoundAgentComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-agent/:agentId"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <ElectionEditOutboundAgent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/callerbook"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <ElectionCallerbook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/number"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <ElectionNumber />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <Developer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recharge"
              element={
                <ProtectedRoute requiredRoles={["owner", "subowner"]}>
                  <VendorBalancePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaign"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <Campaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/demoform"
              element={
                <ProtectedRoute requiredRoles={["owner"]}>
                  <DemoList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approval"
              element={
                <ProtectedRoute requiredRoles={["owner"]}>
                  <Approval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chatboat"
              element={
                <ProtectedRoute requiredRoles={["owner"]}>
                  <ChatbotSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setting"
              element={
                <ProtectedRoute requiredRoles={["owner", "subowner", "vendor"]}>
                  <Setting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AgentScriptFull"
              element={
                <ProtectedRoute requiredRoles={["participant"]}>
                  <AgentScriptFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/SalesPersonInfo"
              element={
                <ProtectedRoute requiredRoles={["participant"]}>
                  <SalesPersonInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/support"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <HelpCenter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/show-ticket"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <ShowTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/outbound/rag"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <VendorKnowledge />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rag"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <VendorKnowledge />
                </ProtectedRoute>
              }
            />
            <Route
              path="/outbound/scripts"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <ScriptandApi />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scripts"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <ScriptandApi />
                </ProtectedRoute>
              }
            />
            <Route
              path="/prompt-template"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <ElectionPromptTemplate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sources/:corpusId"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <CorpusSources />
                </ProtectedRoute>
              }
            />
            <Route
              path="/playground"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <Playground />
                </ProtectedRoute>
              }
            />
            <Route
              path="/callbook"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <CallBook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assignpage"
              element={
                <ProtectedRoute requiredRoles={["participant"]}>
                  <AgentAssignComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assign"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                  <AssignComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/BalanceStatement"
              element={
                <ProtectedRoute requiredRoles={["vendor"]}>
                  <BalanceStatement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/project"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <CreateProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calllogs"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <CallLogsCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/call-history/:campaignId"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <CallHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calllogs/details/:id"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <CallDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Result"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                  <ResultComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/keys"
              element={
                <ProtectedRoute requiredRoles={["owner"]}>
                  <KeysComponent />
                </ProtectedRoute>
              }
            />

            {/* ToxBox CRM Domain Routes */}
            <Route
              path="/crm/dashboard"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant", "subowner"]}>
                  <CRMDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant", "subowner"]}>
                  <CRMLeads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lead-management"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant", "subowner"]}>
                  <CRMLeads mode="campaign" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads/:id"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant", "subowner"]}>
                  <LeadDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/import"
              element={
                <ProtectedRoute requiredRoles={["vendor", "subowner"]}>
                  <LeadImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/followups"
              element={
                <ProtectedRoute requiredRoles={["vendor", "participant", "subowner"]}>
                  <FollowupCalendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/masters"
              element={
                <ProtectedRoute requiredRoles={["vendor", "subowner", "owner"]}>
                  <Masters />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/reports"
              element={
                <ProtectedRoute requiredRoles={["vendor", "subowner", "participant"]}>
                  <CRMReports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calltype"
              element={
                <ProtectedRoute requiredRoles={["participant", "vendor"]}>
                  <CallTypeComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OutboundCallDashboard"
              element={
                <ProtectedRoute requiredRoles={["participant"]}>
                  <OutboundCallDashboard />
                </ProtectedRoute>
              }
            />
            {/* Outbound Routes */}
            <Route path="/outbound">
              <Route
                index
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <OutboundTemplate />
                  </ProtectedRoute>
                }
              />
              <Route path="/outbound/createagent">
                <Route
                  index
                  element={
                    <ProtectedRoute
                      requiredRoles={["subowner", "vendor", "participant"]}
                    >
                      {/* <MultiStepForm isEditMode={false} /> */}
                      <CreateOutBoundAgentComponent isEditMode={false} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="knowledge-bases"
                  element={
                    <ProtectedRoute
                      requiredRoles={["subowner", "vendor", "participant"]}
                    >
                      <KnowledgeBase />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="numbers"
                  element={
                    <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                      <NumberManagement />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path="/outbound/edit-agents/:agentId"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <EditAgentComponent isEditMode={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="template"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <TemplateComponent />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* Inbound Routes */}
            <Route path="/inbound">
              <Route
                index
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <InboundTemplate />
                  </ProtectedRoute>
                }
              />
              <Route path="/inbound/createagent">
                <Route
                  index
                  element={
                    <ProtectedRoute
                      requiredRoles={["subowner", "vendor", "participant"]}
                    >

                      {/* <MultiStepForm isEditMode={true} /> */}
                      <CreateInBoundAgentComponent isEditMode={false} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="knowledge-base"
                  element={
                    <ProtectedRoute
                      requiredRoles={["subowner", "vendor", "participant"]}
                    >
                      <VendorKnowledge />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="script"
                  element={
                    <ProtectedRoute requiredRoles={["vendor", "participant"]}>
                      <ScriptandApi />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="number"
                  element={
                    <ProtectedRoute requiredRoles={["subowner", "vendor"]}>
                      <NumberManagement />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path="edit-agent/:agentId"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    {/* <MultiStepForm isEditMode={true} /> */}
                    <CreateInBoundAgentComponent isEditMode={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="template"
                element={
                  <ProtectedRoute
                    requiredRoles={["subowner", "vendor", "participant"]}
                  >
                    <TemplateComponent />
                  </ProtectedRoute>
                }
              />
            </Route>
            {/* Health Care Domain Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patients"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <Patients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/appointments"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <Appointments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/doctors"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant"]}
                >
                  <Doctors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recruiter/createagent"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  {/* <RecruiterAgnetPage isEditMode={false} /> */}
                  <CreateOutBoundAgentComponent isEditMode={false} />
                </ProtectedRoute>
              }
            />


            <Route
              path="/recruiter/createagent"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  {/* <RecruiterAgnetPage isEditMode={false} /> */}
                  <ElectionEditOutboundAgent />
                </ProtectedRoute>
              }
            />


            <Route
              path="/email-templates"
              element={
                <ProtectedRoute
                  requiredRoles={["owner", "subowner", "vendor", "participant", "salesperson"]}
                >
                  <EmailTemplates />
                </ProtectedRoute>
              }
            />

            <Route
              path="/recruiter/api-key"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <ApiKeyGenerator />
                  {/* <CreateOutBoundAgentComponent isEditMode={false} /> */}
                </ProtectedRoute>
              }
            />

            <Route
              path="/recruiter/all-agents"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <AllRecuiretAgents />
                </ProtectedRoute>
              }
            />

            <Route
              path="/recruiter/prompts"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <RecriterScriptandApi />
                </ProtectedRoute>
              }
            />

            <Route
              path="/recruiter/knoledge-base"
              element={
                <ProtectedRoute
                  requiredRoles={["subowner", "vendor", "participant"]}
                >
                  <RecruiterKnowledge />
                </ProtectedRoute>
              }
            />

            {/* B2B Domain Routes */}
            <Route path="/b2b">
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant", "salesperson"]}>
                    <B2BDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="campaign"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant", "salesperson"]}>
                    <B2BCampaignManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-agent"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <B2BAgentSelection />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-outbound-agent"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <CreateOutBoundAgentComponent isEditMode={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-inbound-agent"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    {/* Reusing CreateInBoundAgentComponent which now has B2B logic */}
                    <CreateInBoundAgentComponent isEditMode={false} />
                  </ProtectedRoute>
                }
              />

              <Route
                path="chatbot-list"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <B2BChatbotList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="agents"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <B2BAgentList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-chatbot"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <CreateB2BChatbot />
                  </ProtectedRoute>
                }
              />
              <Route
                path="phone-numbers"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner"]}>
                    <PhoneNumberManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-outbound-agent-flow"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <B2BMultiStepForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="create-inbound-agent-flow"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant"]}>
                    <B2BMultiStepForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="callbook"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant", "salesperson"]}>
                    <B2BCallBook />
                  </ProtectedRoute>
                }
              />
              <Route
                path="calllogs"
                element={
                  <ProtectedRoute requiredRoles={["vendor", "owner", "subowner", "participant", "salesperson"]}>
                    <B2BCallLogs />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* Routes Not in Sidebar Menus */}
            {/* <Route path="/contect" element={<Navigate to="/" replace />} />
          <Route path="/api" element={<Navigate to="/" replace />} />
          <Route path="/data" element={<Navigate to="/" replace />} />
          <Route path="/subscription" element={<Navigate to="/" replace />} />
          <Route path="/analysis" element={<Navigate to="/" replace />} />
          <Route path="/meta-connect" element={<ConnectMetaAds />} />
          <Route path="/camp" element={<CampaignsDashboard />} />
          <Route path="/lead" element={<LeadsDashboard />} />
          <Route path="/election" element={<CampaignManager/>}/> 
          <Route
            path="/interview/:candidateId"
            element={<InterviewPlatform />}
          />
          <Route path="/interview/complete" element={<InterviewComplete />} /> */}
            {/* Catch-all Route */}
            {/* <Route path="*" element={<Navigate to="/" replace />} /> */}

            <Route path="/connect-whatsapp" element={<ConnectWhatsApp />} />
            <Route
              path="/meta-connect"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <ConnectMetaAds />
                </ProtectedRoute>
              }
            />
            <Route
              path="/camp"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <CampaignsDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lead"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <LeadsDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/election"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <CampaignManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/interview/:candidateId"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <InterviewPlatform />
                </ProtectedRoute>
              }
            />
            <Route
              path="/interview/complete"
              element={
                <ProtectedRoute requiredRoles={["subowner", "vendor", "participant"]}>
                  <InterviewComplete />
                </ProtectedRoute>
              }
            />

            <Route path="/dev-dashboard"
              element={
                <ProtectedRoute requiredRoles={["owner"]}>
                  <DevDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router >
    </>
  );
};

export default App;